import {useQuery, UseQueryResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {NavigateFunction, useNavigate} from 'react-router'

import {QueryKeyName, getPlant} from '../../common/backend'
import {Plant} from '../../types'
import {handleError, retryFunction} from '../apiErrorHandler'

export const usePlant = (plantId: string): UseQueryResult<Plant, AxiosError> => {
  const navigate: NavigateFunction = useNavigate()
  const result = useQuery({
    queryKey: [QueryKeyName.GetPlant, plantId],
    queryFn: async () => {
      return await getPlant(plantId)
    },
    retry: retryFunction,
    refetchOnWindowFocus: false
  })

  const error: AxiosError | null = result.error
  if (error) {
    handleError(error, navigate)
  }

  return result
}
